import { jwtDecode } from 'jwt-decode'

interface UserJwtPayload {
  exp?: number
}

export function isUserTokenValid(token: string | null | undefined): boolean {
  if (!token)
    return false

  try {
    const { exp } = jwtDecode<UserJwtPayload>(token)
    if (!exp)
      return true

    return exp * 1000 > Date.now()
  }
  catch {
    return false
  }
}

export function getValidUserToken(): string | null {
  const userTokenCookie = useCookie('userToken')
  const token = userTokenCookie.value

  if (!token)
    return null

  if (!isUserTokenValid(token)) {
    userTokenCookie.value = null
    return null
  }

  return token
}
